//import { useField } from 'formik';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import { FileField } from '../file-field/file-field';

export const MediaField = (props) => {
  const { onChange, ...other } = props;
  const { setFieldValue } = useFormikContext();

  /**
   * get media info
   * @param {} file
   * @param helpers - formik helpers
   */
  const getMediaInfo = async (file, helpers) => {
    if (!file) {
      const data = { file: '', info: null };
      helpers.setValue(data);
      onChange && onChange(data, helpers);
      return;
    }

    const fileCallbackToPromise = (fileObj) => {
      return Promise.race([
        new Promise((resolve, reject) => {
          fileObj.onerror = () => {
            reject('Ошибка содержимого файла');
          };
          if (fileObj instanceof HTMLImageElement) {
            fileObj.onload = resolve;
          } else if (fileObj instanceof HTMLVideoElement) {
            fileObj.onloadedmetadata = resolve;
          } else {
            reject('Неизвестный тип файла');
          }
        }),
        new Promise((_, reject) => {
          setTimeout(() => reject('Ошибка загрузки файла'), 2000);
        }),
      ]);
    };

    const objectUrl = URL.createObjectURL(file);
    const isVideo = file.type.startsWith('video/');
    let fileInfo, error;
    if (isVideo) {
      const video = document.createElement('video');
      video.src = objectUrl;
      await fileCallbackToPromise(video).catch((errorMsg) => (error = errorMsg));

      fileInfo = {
        duration: video.duration,
        width: video.videoWidth,
        height: video.videoHeight,
        error,
      };
    } else {
      const img = document.createElement('img');
      img.src = objectUrl;
      await fileCallbackToPromise(img).catch((errorMsg) => (error = errorMsg));
      fileInfo = {
        width: img.naturalWidth,
        height: img.naturalHeight,
        error,
      };
    }

    helpers.setValue({ file, info: fileInfo });
    onChange && onChange(fileInfo, { ...helpers, setFieldValue });
  };

  return <FileField {...other} onChange={getMediaInfo} useExternalOnUpdate={true} />;
};

MediaField.defaultProps = {
  type: 'file',
};
MediaField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default MediaField;
